import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useCallback, useState } from "react";
import { useInView } from "react-intersection-observer";
import CommonLtpRenderer from "src/components/ltp-renderer/common-ltp-renderer";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import { getChangeAndChangePercentage, getGreekOptions, getValueOrZero, intComma, } from "../../../../utils/methods";
import { OptionChainCompName } from "../option-chain";
import useDataHook from "../useDataHook";
import useOptionChainSocketHook from "../useOptionChainSocketHook";
import CallOiBox from "./call-oi-box";
import styles from "./oc-row.module.scss";
import TrendColumn from "./trend-column";
import { openGuestLoginModal } from "src/redux/reducers/modals";
const { REACT_APP_URL_ASSET_BASE_PATH } = process.env;
const OCRow = React.forwardRef(({ strike, callOI = 0, callLTP = 0, putLTP = 0, putOI = 0, callMaxOI, putMaxOI, prevOICall, prevOIPut, i, callExch, callExchType, callName, putExch, putExchType, putName, putScripCode, callScripCode, prevCallClose, prevPutClose, onVisibilityChange, isHoverEnabled, symbol, expiry, isChecked, position, selectedOptionType, lotSize, activeStrike, spotScripDetails, }, ref) => {
    const { ref: observerRef, inView } = useInView({
        threshold: 0,
    });
    const openFeedWsHeartBeat = useAppSelector((state) => state.openFeedWs.heartBeat);
    const { PE, CE } = useOptionChainSocketHook(strike == undefined ? 0 : Number(strike), putExch, putExchType, putScripCode, putName, callExch, callExchType, callScripCode, callName, callLTP, prevCallClose, putLTP, prevPutClose, callOI, putOI, false, false, prevOIPut, prevOICall, "", "");
    const { onAddToBasketPut, onAddToWatchlistPut, onBuySellActionPut, onBuySellActionCall, onAddToBasketCall, onAddToWatchlistCall, onChartIconClick, onBulkOrderPlacement, } = useDataHook({
        symbol,
        expiry,
        putName,
        prevPutClose: getValueOrZero(PE.PREVIOUS_CLOSE),
        putExch: PE.EXCH,
        putExchType: PE.EXCH_TYPE,
        putLTP: getValueOrZero(PE.LAST_RATE),
        putScripCode: PE.SCRIPT_CODE,
        callExch: CE.EXCH,
        callExchType: CE.EXCH_TYPE,
        callLTP: getValueOrZero(CE.LAST_RATE),
        callName,
        callScripCode: CE.SCRIPT_CODE,
        prevCallClose: getValueOrZero(CE.PREVIOUS_CLOSE),
        inView,
        observerRef,
        onVisibilityChange,
        strike,
        isChecked: isChecked,
        lotSize,
        selectedOptionType,
        componentName: OptionChainCompName + "_TableRow_" + position,
    });
    // const getOIText = (oi: number): string => {
    //   let newOI = "";
    //   if (oi > 1000) {
    //     newOI = `${(oi / 100000).toFixed(2)} L`;
    //   } else {
    //     return `${oi}`;
    //   }
    //   return newOI;
    // };
    const dispatch = useAppDispatch();
    const [numberOfGreeks, setNumberOfGreeks] = useState();
    let callIndicatorWidth = "0";
    let putIndicatorWidth = "0";
    const totalPrem = getValueOrZero(CE.LAST_RATE) + getValueOrZero(PE.LAST_RATE);
    const upperBreakDown = Number(strike) + totalPrem;
    const lowerBreakDown = Number(strike) - totalPrem;
    const callLtpChangeObj = getChangeAndChangePercentage(CE.LAST_RATE, CE.PREVIOUS_CLOSE);
    const putLtpChangeObj = getChangeAndChangePercentage(PE.LAST_RATE, PE.PREVIOUS_CLOSE);
    if (callMaxOI > 0) {
        callIndicatorWidth = ((getValueOrZero(CE.OI) * 100) / callMaxOI).toFixed(2);
    }
    if (putMaxOI > 0) {
        putIndicatorWidth = ((getValueOrZero(PE.OI) * 100) / putMaxOI).toFixed(2);
    }
    const getGreeksList = getDataFromSession(SESSION_KEYS.GREEKSLIST) || "[]";
    //console.log(getGreeksList, "greek list ");
    const greeksOptions = (getGreeksList === null || getGreeksList === void 0 ? void 0 : getGreeksList.length) > 0 ? getGreeksList : getGreekOptions();
    // console.log(greeksOptions);
    // const [greeksSelected,setGreeksSel]
    // useEffect(() => {
    //   const data = [
    //     { Exch: callExch, ExchType: callExchType, ScripCode: callScripCode },
    //     { Exch: putExch, ExchType: putExchType, ScripCode: putScripCode },
    //   ];
    //   if (inView) {
    //     sendWsMessage(openFeedWsHeartBeat, "Subscribe", data);
    //   } else {
    //     unsubscribeDataByScrip(OptionChainCompName + position, {
    //       Exch: callExch,
    //       ExchType: callExchType,
    //       ScripCode: callScripCode,
    //     });
    //     unsubscribeDataByScrip(OptionChainCompName + position, {
    //       Exch: putExch,
    //       ExchType: putExchType,
    //       ScripCode: putScripCode,
    //     });
    //   }
    // }, [
    //   callExch,
    //   callExchType,
    //   callScripCode,
    //   inView,
    //   openFeedWsHeartBeat,
    //   position,
    //   putExch,
    //   putExchType,
    //   putScripCode,
    // ]);
    const getStraddleTotalPremChange = () => {
        const totalPremPrev = getValueOrZero(PE.PREVIOUS_CLOSE) + getValueOrZero(CE.PREVIOUS_CLOSE);
        const changePercObj = getChangeAndChangePercentage(totalPrem, totalPremPrev);
        return changePercObj;
    };
    const renderedGreeksOptions = () => {
        return (_jsx(_Fragment, { children: greeksOptions.map((greek) => (_jsx("span", { children: greek.id.charAt(0).toUpperCase() +
                    greek.id.slice(1).toLowerCase()
                    ? greek.id.charAt(0).toUpperCase() +
                        greek.id.slice(1).toLowerCase()
                    : console.error(greek.id.charAt(0).toUpperCase() +
                        greek.id.slice(1).toLowerCase()) }, greek.id))) }));
    };
    if (greeksOptions != undefined) {
    }
    const getGreeksData = (greeksObj, keyName) => {
        if (greeksObj != undefined) {
            const greekValue = greeksObj[keyName];
            if (greekValue != undefined) {
                return keyName != "SPEED"
                    ? keyName == "TGR"
                        ? intComma(greekValue, 2)
                        : intComma(greekValue, 4, 4)
                    : intComma(greekValue, 7, 6);
            }
        }
        return "-";
    };
    const renderCallGreeks = () => {
        return (_jsx(_Fragment, { children: greeksOptions.map((greek) => (_jsx("span", { children: getGreeksData(CE.GREEKS_DATA, greek.id) }, greek.id))) }));
    };
    const renderPutGreeks = () => {
        return (_jsx(_Fragment, { children: greeksOptions.map((greek) => (_jsx("span", { children: getGreeksData(PE.GREEKS_DATA, greek.id) }, greek.id))) }));
    };
    const totalPremChangeObj = getStraddleTotalPremChange();
    const commonLtpCallback = useCallback((ltp) => {
        return _jsx("span", Object.assign({ className: "positiveColor mediumWeight smaller" }, { children: ltp }));
        // return <span className="small positiveText">{ltp}</span>;
    }, []);
    return (_jsxs("div", Object.assign({ ref: observerRef }, { children: [selectedOptionType == "Price" && (_jsxs("div", Object.assign({ className: `${styles.optionRow}`, ref: ref }, { children: [_jsxs("div", Object.assign({ className: `${styles.callStatus} ${styles.leftCallStatus}`, style: {
                            backgroundColor: Number(strike) < activeStrike
                                ? "var(--opchainSbBgColor)"
                                : "",
                        } }, { children: [_jsxs("div", Object.assign({ className: styles.ltpOiViewsWrapper }, { children: [_jsx(TrendColumn, { ltp: CE.LAST_RATE, prevClose: CE.PREVIOUS_CLOSE, oi: CE.OI, prevOI: CE.PREV_OI }), _jsxs("div", Object.assign({ className: `${styles.ltpOiViews} posRel` }, { children: [_jsx("div", Object.assign({ className: `${styles.oiView}` }, { children: _jsx(CallOiBox, { oi: CE.OI, oiPerc: getValueOrZero(CE.OI) - getValueOrZero(CE.PREV_OI) + "" }) })), _jsxs("div", Object.assign({ className: `${styles.ltpView}` }, { children: [_jsx("span", Object.assign({ className: `${styles.number} mediumWeight medium` }, { children: intComma(CE.LAST_RATE) })), _jsx("span", Object.assign({ className: `${styles.perc} ${callLtpChangeObj.isNegative
                                                            ? "negativeColor"
                                                            : "positiveColor"} mediumWeight small` }, { children: callLtpChangeObj.differencePercentage }))] })), _jsx("div", Object.assign({ className: `${styles.indicatorCall} ${styles.toolTip}`, style: {
                                                    width: `${callIndicatorWidth}%`,
                                                } }, { children: _jsx("span", Object.assign({ className: styles.toolTiptextLeft }, { children: "open interest" })) }))] }))] })), isHoverEnabled && (_jsxs("ul", Object.assign({ className: `${styles.actionItemList}`, style: {
                                    backgroundColor: Number(strike) > activeStrike
                                        ? "var(--bgColor1)"
                                        : "var(--opchainSbBgColor)",
                                    left: 0,
                                } }, { children: [_jsx("li", { children: _jsxs("div", Object.assign({ className: "buySellButtonPanel" }, { children: [_jsx("button", Object.assign({ onClick: () => onBuySellActionCall("Mini Option Chain - Price", true) }, { children: "B" })), _jsx("button", Object.assign({ onClick: () => onBuySellActionCall("Mini Option Chain - Price", false) }, { children: "S" }))] })) }), _jsx("li", Object.assign({ onClick: () => onAddToBasketCall("Mini Option Chain - Price") }, { children: _jsx("span", { className: "basketIconBlue", title: "Add to basket" }) })), _jsx("li", Object.assign({ className: "pointer" }, { children: _jsx("span", { className: "watchlistIconBlue", 
                                            //onClick={() => onAddToWatchlistCall("Mini OC - Price")}
                                            onClick: () => dispatch(openGuestLoginModal()), title: "Add to watchlist" }) })), _jsx("li", Object.assign({ onClick: () => dispatch(openGuestLoginModal()) }, { children: _jsx("span", { className: "chartIcon", title: "Chart" }) }))] })))] })), _jsx("div", Object.assign({ className: `${styles.oiView} ${styles.equal} ${styles.strikeCol} `, style: { alignSelf: "center" } }, { children: _jsx("div", Object.assign({ className: styles.spWrapper }, { children: _jsxs("div", Object.assign({ className: styles.spView }, { children: [_jsx("span", Object.assign({ className: `${styles.oi} mediumWeight medium` }, { children: (strike === null || strike === void 0 ? void 0 : strike.includes("."))
                                            ? intComma(strike)
                                            : intComma(strike, 0) })), activeStrike == Number(strike) && spotScripDetails && (_jsx(CommonLtpRenderer, { scripCode: spotScripDetails.ScripCode, exch: spotScripDetails.Exch, exchType: spotScripDetails.ExchType, ltp: spotScripDetails.LastRate, prevLtp: spotScripDetails.PrevClose, renderElement: commonLtpCallback, componentName: OptionChainCompName + "_TableRow_" + position }))] })) })) })), _jsxs("div", Object.assign({ className: styles.callStatus, style: {
                            backgroundColor: Number(strike) > activeStrike
                                ? "var(--opchainSbBgColor)"
                                : "",
                        } }, { children: [_jsxs("div", Object.assign({ className: styles.ltpOiViewsWrapper }, { children: [_jsxs("div", Object.assign({ className: `${styles.ltpOiViews} posRel` }, { children: [_jsxs("div", Object.assign({ className: `${styles.ltpView}` }, { children: [_jsx("span", Object.assign({ className: `${styles.number} mediumWeight medium` }, { children: intComma(PE.LAST_RATE) })), _jsx("span", Object.assign({ className: `${styles.perc} ${putLtpChangeObj.isNegative
                                                            ? "negativeColor"
                                                            : "positiveColor"} mediumWeight small` }, { children: putLtpChangeObj.differencePercentage }))] })), _jsx("div", Object.assign({ className: `${styles.oiView}` }, { children: _jsx(CallOiBox, { oi: PE.OI, oiPerc: getValueOrZero(PE.OI) - getValueOrZero(PE.PREV_OI) + "" }) })), _jsx("div", Object.assign({ className: `${styles.indicatorPut} ${styles.toolTip}`, style: {
                                                    width: `${putIndicatorWidth}%`,
                                                } }, { children: _jsx("span", Object.assign({ className: styles.toolTiptextRight }, { children: "open interest" })) }))] })), _jsx(TrendColumn, { ltp: PE.LAST_RATE, prevClose: PE.PREVIOUS_CLOSE, oi: PE.OI, prevOI: PE.PREV_OI })] })), isHoverEnabled && (_jsxs("ul", Object.assign({ className: `${styles.actionItemList}`, style: {
                                    backgroundColor: Number(strike) > activeStrike
                                        ? "var(--opchainSbBgColor)"
                                        : "var(--bgColor1)",
                                    right: 0,
                                } }, { children: [_jsx("li", Object.assign({ onClick: () => dispatch(openGuestLoginModal()) }, { children: _jsx("span", { className: "chartIcon", title: "Chart" }) })), _jsx("li", Object.assign({ className: "pointer" }, { children: _jsx("span", { className: "watchlistIconBlue", onClick: () => dispatch(openGuestLoginModal()), 
                                            // onClick={() => onAddToWatchlistPut("Mini OC - Price")}
                                            title: "Add to watchlist" }) })), _jsx("li", Object.assign({ onClick: () => onAddToBasketPut("Mini OC - Price") }, { children: _jsx("span", { className: "basketIconBlue", title: "Add to basket" }) })), _jsx("li", { children: _jsxs("div", Object.assign({ className: "buySellButtonPanel" }, { children: [_jsx("button", Object.assign({ onClick: () => onBuySellActionPut("Mini Option Chain - Price", true) }, { children: "B" })), _jsx("button", Object.assign({ onClick: () => onBuySellActionPut("Mini Option Chain - Price", false) }, { children: "S" }))] })) })] })))] }))] }))), selectedOptionType == "Straddle" && (_jsxs("div", Object.assign({ className: `${styles.straddleRow}`, ref: ref }, { children: [_jsx("div", Object.assign({ className: `${styles.strikeCol} ${styles.colTD} ${Number(strike) == activeStrike ? styles.strikeFix : "medium"} ` }, { children: _jsxs("div", Object.assign({ className: `${styles.strikeColBg}` }, { children: [_jsx("span", { children: (strike === null || strike === void 0 ? void 0 : strike.includes("."))
                                        ? intComma(strike)
                                        : intComma(strike, 0) }), activeStrike == Number(strike) && spotScripDetails && (_jsx(CommonLtpRenderer, { scripCode: spotScripDetails.ScripCode, exch: spotScripDetails.Exch, exchType: spotScripDetails.ExchType, ltp: spotScripDetails.LastRate, prevLtp: spotScripDetails.PrevClose, renderElement: commonLtpCallback, componentName: OptionChainCompName + "_TableRow_" + position }))] })) })), _jsxs("div", Object.assign({ className: `${styles.colTD}` }, { children: [intComma(CE.LAST_RATE), _jsx("div", Object.assign({ className: `${styles.perc} ${callLtpChangeObj.isNegative
                                    ? "negativeColor"
                                    : "positiveColor"} mediumWeight small` }, { children: callLtpChangeObj.differencePercentage }))] })), _jsxs("div", Object.assign({ className: `${styles.colTD}` }, { children: [intComma(PE.LAST_RATE), _jsxs("div", Object.assign({ className: `${styles.perc} ${putLtpChangeObj.isNegative ? "negativeColor" : "positiveColor"} mediumWeight small` }, { children: [putLtpChangeObj.differencePercentage, " "] }))] })), _jsxs("div", Object.assign({ className: `${styles.colTD} ` }, { children: [intComma(totalPrem), _jsx("div", Object.assign({ className: `${styles.perc} ${totalPremChangeObj.isNegative
                                    ? "negativeColor"
                                    : "positiveColor"} mediumWeight small` }, { children: totalPremChangeObj.differencePercentage }))] })), _jsxs("div", Object.assign({ className: `${styles.colTD}` }, { children: [intComma(upperBreakDown), " ", _jsx("div", { children: intComma(lowerBreakDown) })] })), isHoverEnabled && (_jsx("ul", Object.assign({ className: `${styles.actionItemList} pe-0` }, { children: _jsx("li", { children: _jsxs("div", Object.assign({ className: "buySellButtonPanel" }, { children: [_jsx("button", Object.assign({ onClick: () => onBulkOrderPlacement(true, "Mini Option Chain - Straddle") }, { children: "B" })), _jsx("button", Object.assign({ onClick: () => onBulkOrderPlacement(false, "Mini Option Chain - Straddle") }, { children: "S" }))] })) }) })))] }))), selectedOptionType == "Greeks" && (
            // <>
            //   <div
            //     className={`${styles.greeksRow}`}
            //     ref={ref}
            //     // style={{ backgroundColor: "yellow" }}
            //   >
            //     <div
            //       className={`${styles.leftGreeks} px-2`}
            //       style={{
            //         backgroundColor:
            //           Number(strike) < activeStrike
            //             ? "var(--opchainSbBgColor)"
            //             : "",
            //       }}
            //     >
            //       <div className={`${styles.colTD} d-flex flex-column textLeft`}>
            //         <span>{convertNumberIntoLakhsAndCroreWithSign(CE.OI)}</span>
            //         <span
            //           className={` ${
            //             getValueOrZero(CE.PREV_OI) > 0
            //               ? "positiveColor"
            //               : "negativeColor"
            //           } medium`}
            //         >
            //           {`${convertNumberIntoLakhsAndCroreWithSign(
            //             getValueOrZero(CE.OI) - getValueOrZero(CE.PREV_OI)
            //           )}`}
            //         </span>
            //         {renderedGreeksOptions()}
            //       </div>
            //       <div className={`${styles.colTD} d-flex flex-column textRight`}>
            //         <span>{intComma(CE.LAST_RATE)}</span>
            //         <span
            //           className={` ${
            //             callLtpChangeObj.isNegative
            //               ? "negativeColor"
            //               : "positiveColor"
            //           } medium`}
            //         >
            //           {callLtpChangeObj.differencePercentage}
            //         </span>
            //         {renderCallGreeks()}
            //       </div>
            //       <div
            //         className={`${styles.callBorder}`}
            //         style={{ width: `${callIndicatorWidth}%` }}
            //       ></div>
            //       {isHoverEnabled && (
            //         <ul
            //           className={`${styles.actionItemList}`}
            //           style={{
            //             backgroundColor:
            //               Number(strike) < activeStrike
            //                 ? "var(--opchainSbBgColor)"
            //                 : "",
            //           }}
            //         >
            //           <li>
            //             <div className="buySellButtonPanel">
            //               <button
            //                 onClick={() =>
            //                   onBuySellActionCall(
            //                     "Mini Option Chain - Greeks",
            //                     true
            //                   )
            //                 }
            //               >
            //                 B
            //               </button>
            //               <button
            //                 onClick={() =>
            //                   onBuySellActionCall(
            //                     "Mini Option Chain - Greeks",
            //                     false
            //                   )
            //                 }
            //               >
            //                 S
            //               </button>
            //             </div>
            //           </li>
            //           <li
            //             onClick={() =>
            //               onAddToBasketCall("Mini Option Chain - Greeks")
            //             }
            //           >
            //             <span
            //               className="basketIconBlue"
            //               title="Add to basket"
            //             ></span>
            //           </li>
            //           <li className="pointer">
            //             {/* <img
            //               src={
            //                 getEnvironmentVariableOrEmpty(
            //                   REACT_APP_URL_ASSET_BASE_PATH
            //                 ) + "/fno/assets/svgs/watchlist.svg"
            //               }
            //               alt=""
            //               onClick={() => onAddToWatchlistCall("Mini OC - Greeks")}
            //               title="Add to watchlist"
            //             /> */}
            //             <span
            //               className="watchlistIconBlue"
            //               onClick={() => onAddToWatchlistCall("Mini OC - Greeks")}
            //               title="Add to watchlist"
            //             ></span>
            //           </li>
            //           <li>
            //             <span
            //               className="chartIcon pointer"
            //               onClick={() =>
            //                 onChartIconClick("CE", "Mini OC - Greeks")
            //               }
            //             ></span>
            //           </li>
            //         </ul>
            //       )}
            //     </div>
            //     <div className={`${styles.colTD} ${styles.strikeCol} textCenter`}>
            //       <div className={`${styles.strikeColBg}`}>
            //         <span>
            //           {strike?.includes(".")
            //             ? intComma(strike)
            //             : intComma(strike, 0)}
            //         </span>
            //         {activeStrike == Number(strike) && spotScripDetails && (
            //           <CommonLtpRenderer
            //             scripCode={spotScripDetails.ScripCode}
            //             exch={spotScripDetails.Exch}
            //             exchType={spotScripDetails.ExchType}
            //             ltp={spotScripDetails.LastRate}
            //             prevLtp={spotScripDetails.PrevClose}
            //             renderElement={commonLtpCallback}
            //             componentName={
            //               OptionChainCompName + "_TableRow_" + position
            //             }
            //           ></CommonLtpRenderer>
            //         )}
            //       </div>
            //     </div>
            //     <div
            //       className={`${styles.rightGreeks} ps-2`}
            //       style={{
            //         backgroundColor:
            //           Number(strike) > activeStrike
            //             ? "var(--opchainSbBgColor)"
            //             : "",
            //       }}
            //     >
            //       <div className={`${styles.colTD} d-flex flex-column textLeft`}>
            //         <span>{intComma(PE.LAST_RATE)}</span>
            //         <span
            //           className={` ${
            //             putLtpChangeObj.isNegative
            //               ? "negativeColor"
            //               : "positiveColor"
            //           }`}
            //         >
            //           {putLtpChangeObj.differencePercentage}
            //         </span>
            //         {/* <span>Delta</span>
            //         <span>Theta</span>
            //         <span>Vega</span>
            //         <span>Gamma</span>
            //         <span>IV</span> */}
            //         {renderedGreeksOptions()}
            //       </div>
            //       <div
            //         className={`${styles.colTD}  d-flex flex-column textRight`}
            //       >
            //         <span>{convertNumberIntoLakhsAndCroreWithSign(PE.OI)}</span>
            //         <span
            //           className={` ${
            //             getValueOrZero(PE.PREV_OI) > 0
            //               ? "positiveColor"
            //               : "negativeColor"
            //           } `}
            //         >
            //           {`${convertNumberIntoLakhsAndCroreWithSign(
            //             getValueOrZero(PE.OI) - getValueOrZero(PE.PREV_OI)
            //           )}`}
            //         </span>
            //         {renderPutGreeks()}
            //       </div>
            //       <div
            //         className={`${styles.putBorder}`}
            //         style={{ width: `${putIndicatorWidth}%` }}
            //       ></div>
            //       {isHoverEnabled && (
            //         <ul
            //           className={`${styles.actionItemList}`}
            //           style={{
            //             backgroundColor:
            //               Number(strike) > activeStrike
            //                 ? "var(--opchainSbBgColor)"
            //                 : "",
            //           }}
            //         >
            //           <li>
            //             <span
            //               className="chartIcon pointer"
            //               onClick={() =>
            //                 onChartIconClick("PE", "Mini OC - Greeks")
            //               }
            //             ></span>
            //           </li>
            //           <li className="pointer">
            //             {/* <img
            //               src={
            //                 getEnvironmentVariableOrEmpty(
            //                   REACT_APP_URL_ASSET_BASE_PATH
            //                 ) + "/fno/assets/svgs/watchlist.svg"
            //               }
            //               alt=""
            //               onClick={() => onAddToWatchlistPut("Mini OC - Greeks")}
            //               title="Add to watchlist"
            //             /> */}
            //             <span
            //               className="watchlistIconBlue"
            //               onClick={() => onAddToWatchlistPut("Mini OC - Greeks")}
            //               title="Add to watchlist"
            //             ></span>
            //           </li>
            //           <li onClick={() => onAddToBasketPut("Mini OC - Greeks")}>
            //             <span
            //               className="basketIconBlue"
            //               title="Add to basket"
            //             ></span>
            //           </li>
            //           <li>
            //             <div className="buySellButtonPanel">
            //               <button
            //                 onClick={() =>
            //                   onBuySellActionPut(
            //                     "Mini Option Chain - Greeks",
            //                     true
            //                   )
            //                 }
            //               >
            //                 B
            //               </button>
            //               <button
            //                 onClick={() =>
            //                   onBuySellActionPut(
            //                     "Mini Option Chain - Greeks",
            //                     false
            //                   )
            //                 }
            //               >
            //                 S
            //               </button>
            //             </div>
            //           </li>
            //         </ul>
            //       )}
            //     </div>
            //   </div>
            //   {/* Old Code  */}
            //   <div className={`${styles.newGreeksRow} d-none`} ref={ref}>
            //     <div
            //       className={`${styles.leftGreeks}`}
            //       style={{
            //         backgroundColor:
            //           Number(strike) < activeStrike
            //             ? "var(--opchainSbBgColor)"
            //             : "",
            //       }}
            //     >
            //       <div className={`d-flex justify-content-between textLeft px-2`}>
            //         <div className={`d-flex flex-column w-50 pe-1`}>
            //           <span className="medium">
            //             {convertNumberIntoLakhsAndCroreWithSign(CE.OI)}
            //           </span>
            //           <span
            //             className={` ${
            //               getValueOrZero(CE.PREV_OI) > 0
            //                 ? "positiveColor"
            //                 : "negativeColor"
            //             } `}
            //           >
            //             {convertNumberIntoLakhsAndCroreWithSign(CE.PREV_OI)}
            //           </span>
            //         </div>
            //         <div className={`d-flex flex-column w-50 ps-1`}>
            //           <span className={` medium`}>{intComma(CE.LAST_RATE)}</span>
            //           <span
            //             className={` ${
            //               callLtpChangeObj.isNegative
            //                 ? "negativeColor"
            //                 : "positiveColor"
            //             } small`}
            //           >
            //             {callLtpChangeObj.differencePercentage}
            //           </span>
            //         </div>
            //       </div>
            //       <div className={`${styles.deltaWrapper}`}>
            //         <div className={`${styles.leftDelta} d-flex pe-2`}>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Delta</span>
            //             <span className={styles.deltaValue}>calldelta</span>
            //           </div>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Theta</span>
            //             <span className={styles.deltaValue}>caltheta</span>
            //           </div>
            //         </div>
            //         <div className={`${styles.leftDelta} ps-2 d-flex`}>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Vega</span>
            //             <span className={styles.deltaValue}>callvega</span>
            //           </div>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Gamma</span>
            //             <span className={styles.deltaValue}>callgamma</span>
            //           </div>
            //         </div>
            //         <div className={`${styles.deltaRow} d-flex`}></div>
            //       </div>
            //       <div
            //         className={`${styles.callBorder}`}
            //         style={{ width: `${callIndicatorWidth}%` }}
            //       ></div>
            //       {isHoverEnabled && (
            //         <ul
            //           className={`${styles.actionItemList}`}
            //           style={{
            //             backgroundColor:
            //               Number(strike) < activeStrike
            //                 ? "var(--opchainSbBgColor)"
            //                 : "",
            //           }}
            //         >
            //           <li>
            //             <div className="buySellButtonPanel">
            //               <button
            //                 onClick={() => onBuySellActionCall("Mini OC", true)}
            //               >
            //                 B
            //               </button>
            //               <button
            //                 onClick={() => onBuySellActionCall("Mini OC", false)}
            //               >
            //                 S
            //               </button>
            //             </div>
            //           </li>
            //           <li onClick={() => onAddToBasketCall("Mini OC")}>
            //             <span
            //               className="basketIconBlue"
            //               title="Add to basket"
            //             ></span>
            //           </li>
            //           <li className="pointer">
            //             {/* <img
            //               src={
            //                 getEnvironmentVariableOrEmpty(
            //                   REACT_APP_URL_ASSET_BASE_PATH
            //                 ) + "/fno/assets/svgs/watchlist.svg"
            //               }
            //               alt=""
            //               onClick={() => onAddToWatchlistCall("Mini OC")}
            //               title="Add to watchlist"
            //             /> */}
            //             <span
            //               className="watchlistIconBlue"
            //               onClick={() => onAddToWatchlistCall("Mini OC")}
            //               title="Add to watchlist"
            //             ></span>
            //           </li>
            //           <li>
            //             <span
            //               className="chartIcon pointer"
            //               onClick={() => onChartIconClick("CE", "Mini OC")}
            //             ></span>
            //           </li>
            //         </ul>
            //       )}
            //     </div>
            //     <div className={`${styles.middleGreeks} `}>
            //       <div
            //         className={`${styles.strikeCol} ${styles.colTD} ${
            //           Number(strike) == activeStrike ? styles.strikeFix : "medium"
            //         }`}
            //       >
            //         <div className={`${styles.strikeColBg}  `}>
            //           <span>
            //             {strike?.includes(".")
            //               ? intComma(strike)
            //               : intComma(strike, 0)}
            //           </span>
            //           {activeStrike == Number(strike) && spotScripDetails && (
            //             <CommonLtpRenderer
            //               scripCode={spotScripDetails.ScripCode}
            //               exch={spotScripDetails.Exch}
            //               exchType={spotScripDetails.ExchType}
            //               ltp={spotScripDetails.LastRate}
            //               prevLtp={spotScripDetails.PrevClose}
            //               renderElement={commonLtpCallback}
            //               componentName={
            //                 OptionChainCompName + "_TableRow_" + position
            //               }
            //             ></CommonLtpRenderer>
            //           )}
            //         </div>
            //       </div>
            //     </div>
            //     <div
            //       className={`${styles.rightGreeks}`}
            //       style={{
            //         backgroundColor:
            //           Number(strike) > activeStrike
            //             ? "var(--opchainSbBgColor)"
            //             : "",
            //       }}
            //     >
            //       <div className={`d-flex justify-content-between textLeft px-2`}>
            //         <div className={`d-flex flex-column w-50 ps-1`}>
            //           <span className={` medium`}>{intComma(PE.LAST_RATE)}</span>
            //           <span
            //             className={` ${
            //               putLtpChangeObj.isNegative
            //                 ? "negativeColor"
            //                 : "positiveColor"
            //             } small`}
            //           >
            //             {putLtpChangeObj.differencePercentage}
            //           </span>
            //         </div>
            //         <div className={`d-flex flex-column w-50 pe-1`}>
            //           <span className="medium">
            //             {convertNumberIntoLakhsAndCroreWithSign(PE.OI)}
            //           </span>
            //           <span
            //             className={` ${
            //               getValueOrZero(PE.PREV_OI) > 0
            //                 ? "positiveColor"
            //                 : "negativeColor"
            //             } small`}
            //           >
            //             {convertNumberIntoLakhsAndCroreWithSign(PE.PREV_OI)}
            //           </span>
            //         </div>
            //       </div>
            //       <div className={`${styles.deltaWrapper}`}>
            //         <div className={`${styles.leftDelta} d-flex pe-2`}>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Delta</span>
            //             <span className={styles.deltaValue}>putdelta</span>
            //           </div>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Theta</span>
            //             <span className={styles.deltaValue}>puttheta</span>
            //           </div>
            //         </div>
            //         <div className={`${styles.leftDelta} ps-2 d-flex`}>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Vega</span>
            //             <span className={styles.deltaValue}>putvega</span>
            //           </div>
            //           <div className={styles.deltaRow}>
            //             <span className="textLeft">Gamma</span>
            //             <span className={styles.deltaValue}>xputgamma</span>
            //           </div>
            //         </div>
            //         <div className={`${styles.deltaRow} d-flex`}></div>
            //       </div>
            //       <div className="d-flex justify-content-end">
            //         <div
            //           className={`${styles.putBorder}`}
            //           style={{ width: `${putIndicatorWidth}%` }}
            //         ></div>
            //       </div>
            //       {isHoverEnabled && (
            //         <ul className={`${styles.actionItemList}`}>
            //           <li>
            //             <span
            //               className="chartIcon pointer"
            //               onClick={() => onChartIconClick("PE", "Mini OC")}
            //             ></span>
            //           </li>
            //           <li className="pointer">
            //             {/* <img
            //               src={
            //                 getEnvironmentVariableOrEmpty(
            //                   REACT_APP_URL_ASSET_BASE_PATH
            //                 ) + "/fno/assets/svgs/watchlist.svg"
            //               }
            //               alt=""
            //               onClick={() => onAddToWatchlistPut("Mini OC")}
            //               title="Add to watchlist"
            //             /> */}
            //             <span
            //               className="watchlistIconBlue"
            //               onClick={() => onAddToWatchlistPut("Mini OC")}
            //               title="Add to watchlist"
            //             ></span>
            //           </li>
            //           <li onClick={() => onAddToBasketPut("Mini OC")}>
            //             <span
            //               className="basketIconBlue"
            //               title="Add to basket"
            //             ></span>
            //           </li>
            //           <li>
            //             <div className="buySellButtonPanel">
            //               <button
            //                 onClick={() => onBuySellActionPut("Mini OC", true)}
            //               >
            //                 Bml
            //               </button>
            //               <button
            //                 onClick={() => onBuySellActionPut("Mini OC", false)}
            //               >
            //                 S
            //               </button>
            //             </div>
            //           </li>
            //         </ul>
            //       )}
            //     </div>
            //   </div>
            // </>
            _jsx(_Fragment, {}))] })));
});
OCRow.displayName = "OCRow";
export default memo(OCRow);
